export enum TeleportationTarget {
  AppTop = '.app-top',
}

export default TeleportationTarget
